import List from './List';

const Components = {
    List : List
}

export default Components;